import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "64",
  height: "64",
  rx: "32",
  fill: "#4EA6EC"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M32 20.0015C32.5523 20.0015 33 20.4492 33 21.0015V32.5877L36.543 29.0456C36.9336 28.6552 37.5667 28.6553 37.9572 29.0458C38.3477 29.4364 38.3476 30.0696 37.957 30.46L32.707 35.7087C32.3165 36.0991 31.6835 36.0991 31.293 35.7087L26.043 30.46C25.6524 30.0696 25.6523 29.4364 26.0428 29.0458C26.4333 28.6553 27.0664 28.6552 27.457 29.0456L31 32.5877V21.0015C31 20.4492 31.4477 20.0015 32 20.0015ZM22 35.0015C22 34.4492 21.5523 34.0015 21 34.0015C20.4477 34.0015 20 34.4492 20 35.0015V42.0015C20 42.5319 20.2107 43.0406 20.5858 43.4157C20.9609 43.7908 21.4696 44.0015 22 44.0015H42C42.5304 44.0015 43.0391 43.7908 43.4142 43.4157C43.7893 43.0406 44 42.5319 44 42.0015V35.0015C44 34.4492 43.5523 34.0015 43 34.0015C42.4477 34.0015 42 34.4492 42 35.0015V42.0015H22V35.0015Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }